module.exports = __webpack_public_path__ + "img/zy.16e0b627.png";